import { createTheme } from '@mui/material';

export const Light = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#435C4A',
            contrastText: '#FFFFFF'
        },
        background: {
            default: '#F5F5F5'
        }
    },
    components: {
        MuiTableCell: {
            styleOverrides: {
                head: {
                    backgroundColor: '#435C4A4D',
                    color: '#000000',
                    fontWeight: 600
                }
            }
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&:nth-of-type(even)': {
                        backgroundColor: '#3C3C3C0D'
                    }
                }
            }
        }
    }
});
